export const getResourcesSourcesReadonlyVars = {
  state: {
    in: ['Unpublished', 'Published'],
  },
}
